// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Success-module__wrapper___3ECnA","wrapperOnBoarder":"Success-module__wrapperOnBoarder___QWXNA","button":"Success-module__button___2ytEL"};